export default [
  {
    path: '/app/trash-bin',
    name: 'TrashBin',
    component: () => import('@/views/TrashBin/Index.vue'),
    meta: {
      pageTitle: 'Silinmiş Öğeler',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_TRASH_BIN',
      action: 'read',
    },
  },
]
